import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import Util from '../../util/UtilClass';
import { PulseLoader } from 'halogenium';
import MenuItemOptions from './MenuItemModal/MenuItemOption';
import TableSessionHelper from '../../Model/TableSession';
import MenuItemImageGallery from '../../app/User/MenuItem/Image/MenuItemImageGallery';
import MenuItemImageRepository from '../../app/User/MenuItem/Image/MenuItemImageRepository';
import { TableType } from '../../components/merchant/Enum/TableType';
import WorkingHourHandler from '../../app/User/Handler/WorkingHourHandler';
import DOMPurify from 'dompurify';
import QuantityAdjust from './MenuItemModal/QuantityAdjust';
import OrderSetButton from './../../jsx/components/OrderSetButton';
import OrderItem, { cloneOrder, getSideDishMessage, handleSideDishChange, handleVariationQuantityChange, toggleSideDish, uniqueUuid } from '../../Model/OrderItem';
import { StatusType } from '../../Model/Status';
import ReactHelper from '../../util/ReactHelper';
import { pageReload } from '../../util/PageReload';
import ModuleHelper, { moduleKey } from '../../app/User/Helper/ModuleHelper';

const ERR_TABLE_SESSION_NOT_FOUND = 1000;

export const CollapseWhenOtherExpandType = {
    // When any group is expanded, we shall collapse this item
    all: "all",

    // We only collapse this item when other item in same group is expanded
    sameGroup: "sameGroup",

    // Never auto collapse
    never: "never",
}

let _joiningTable = false
let _joinTableCallbacks = []
class MenuItemModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#menu-item-modal-portal').length == 0) {
            $('body').prepend('<div id="menu-item-modal-portal"></div>')
        }
        this.portalRoot = document.getElementById("menu-item-modal-portal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el);
    };
    onClose = () => { }
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}

const hotProductIcon = <i className="far fa-thumbs-up fa-2x hot-pick" style={{ marginLeft: '5px' }} />
class MenuItemModal extends Component {
    constructor(props) {
        super(props);
        if (!this.props.menuItem) {
            this.state = {
                isItemMissing: true
            }
            return
        }
        let { choices, addons, options } = this.props.menuItem.getVariations()
        let variations = addons.concat(options)

        let openModalOriginalQuantity = 0
        if (this.props.order != null) {

            this.state = {
                order: cloneOrder(this.props.order),
                ordering: false,
                selected_choices: choices.filter((item) => this.props.order.option_ids.includes(item.id)),
                selected_variations: this.props.order.variation_ids != undefined ? variations.filter((item) => this.props.order.variation_ids.includes(item.id)) : [],
                order_quantity: this.props.order.quantity,
                setNumber: this.props.order.set_number || this.props.setNumber || null,
            }
            openModalOriginalQuantity = this.props.order.quantity
        } else {
            this.state = {
                // Mark that we are adding new item instead of edit order
                isNewItem: true,
                order: Object.assign(new OrderItem(), { menu_item_id: this.props.menuItem.id, order_status: 'draft', quantity: 0 }),
                ordering: false,
                selected_choices: choices.length > 0 ? [choices.every(val => val.in_stock != true) ? choices[0] : choices.find( choice => choice.in_stock == true)] : [],
                selected_variations: [],
                order_quantity: 1,
                setNumber: this.props.setNumber || null,
            }

            // New item, actually start with 0 quantity, we "update" to 1, so
            openModalOriginalQuantity = 0
        }


        this.state = {
            ...this.state,
            menuItemImages: [],
            sideDishForceExpand: [],
            isSideDishCompleted: {},
            isOrderTimeExpired: this.isOrderTimeExpired(),
            isTableSessionExpired: this.isTableSessionExpired(),
            choiceVariationOptionSideDish: this.getItemChoiceVariationOptionSideDish(),

            // Inventory calculation will based on this
            openModalOriginalQuantity: openModalOriginalQuantity,
        }
        let isOutOfStock = this.isOutOfStock(this.state.order_quantity, this.state.order_quantity)
        this.state.isOutOfStock = isOutOfStock

        this.sideDishContainerRef = {}
        // this.sideDishContainerRef = React.createRef()
    }

    componentDidMount() {
        let isNotYetJoinActiveTable = TableSessionHelper.isNeedToTriggerJoinTable()
        if (isNotYetJoinActiveTable) {
            this.props.app.setState({
                joiningTable: true
            })
        }

        // this.props.menuItem can be null if suddenly
        // admin decides to remove the item after this modal is loaded
        if (!this.props.menuItem) {
            this.props.onClose()
            return
        }

        MenuItemImageRepository
            .getInstance(this.props.app)
            .loadImage(this.props.menuItem, (menuItemImages) => {
                menuItemImages.sort((a,b) => a.sort - b.sort)
                this.setState({menuItemImages})
            }, this.props.menuItem.id)
        this.handleSideDish()
    }
    componentWillUnmount = () => {
        this.unmounted = true
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.props.menuItem) {
            this.props.onClose()
        }
        let isNeedFocusSideGroup = this.state.isNeedFocusSideGroup
        if (this.state.isNeedFocus == "side-dish" && prevState.isNeedFocus != this.state.isNeedFocus && this.sideDishContainerRef[isNeedFocusSideGroup] && this.sideDishContainerRef[isNeedFocusSideGroup].current) {
            let sideMenuRect = this.sideDishContainerRef[isNeedFocusSideGroup].current.getBoundingClientRect()
            let menuModalHeaderRect = $('.menu-modal-header')[0].getBoundingClientRect()

            let offset = sideMenuRect.top - (menuModalHeaderRect.bottom + 5)
            if (offset < 0) {
                // Side Menu to scrolled away and blocked by menuModalHeade
                // scroll it back into view
                if ($('.react-modal-body').length && $('.react-modal-body')[0]) {
                    $('.react-modal-body')[0].scrollTop += offset
                }
            }
        }

        ReactHelper.handleComponentDidUpdate(this, ["variation"], () => {
            this.setState({
                choiceVariationOptionSideDish: this.getItemChoiceVariationOptionSideDish(),
            })
        })

        ReactHelper.handleComponentDidUpdate(this, ["temporaryTableQr"], () => {
            this.setState({
                isOrderTimeExpired: this.isOrderTimeExpired(),
                isTableSessionExpired: this.isTableSessionExpired(),
            })
        })

        ReactHelper.handleComponentDidUpdate(this, ["menuItems"], () => {
            this.setState({
                isOutOfStock: this.isOutOfStock(this.state.order_quantity),
            })
        })
    }

    isOrderTimeExpired = () => {
        const { temporaryTableQr } = this.props.app.state
        if (temporaryTableQr) {
            const lastOrderTime = moment(temporaryTableQr.expire_at)
            return lastOrderTime.isBefore(moment())
        }
        return false
    }
    isTableSessionExpired = () => {
        const { temporaryTableQr } = this.props.app.state
        if (temporaryTableQr) {
            return temporaryTableQr.status_id != StatusType.ACTIVE
        }
        return false
    }

    onClose() {
        $("body").removeClass("modal-open");
        this.props.onClose()
    }

    // Event
    onVariationSelected = (variation) => {
        if (variation.type == 0) {
            let check = !!this.state.selected_variations.find(item => item.id == variation.id)
            let selectedVariations = this.state.selected_variations
            if (!check) {
                selectedVariations.push(variation)
            }
            else {
                selectedVariations = selectedVariations.filter((value) => value.id != variation.id)
            }
            this.setState({
                selected_variations: selectedVariations
            })
        } else if (variation.type == 1) {
            let selected = !!this.state.selected_choices.find(item => item.id == variation.id)
            if (!selected) {
                this.setState({
                    selected_choices: [
                        variation
                    ]
                })
            }
        }
    }

    /**
     *
     * @param {Object} variation
     * @param {Boolean} isAdd - true = add 1 to current quantity, false = -1 from current quantity
     */
     onVariationQuantityChange = (variation, isAdd) => {
        let { order, } = this.state
        let _variationOverMaxQuantity = [...(this.state.variationOverMaxQuantity || [])]
        let { overMaxQuantity, order: orderItem, currentItemQuantity, } = handleVariationQuantityChange({order, variation, isAdd, overMaxQuantity: _variationOverMaxQuantity, })

        if (overMaxQuantity && overMaxQuantity.length) {
            if (this.variationOverMaxQuantityTimer) {
                clearTimeout(this.variationOverMaxQuantityTimer)
            }
            this.variationOverMaxQuantityTimer = setTimeout(() => {
                this.setState({variationOverMaxQuantity: []})
            }, 2000)
        }

        // Add/remove to selected variation array
        let check = !!this.state.selected_variations.find(item => item.id == variation.id)
        let selectedVariations = this.state.selected_variations
        if (!check && currentItemQuantity > 0) {
            selectedVariations.push(variation)
        }
        else if (check && currentItemQuantity <= 0) {
            selectedVariations = selectedVariations.filter((value) => value.id != variation.id)
        }

        this.setState({
            order: orderItem,
            variationOverMaxQuantity: overMaxQuantity,
            selected_variations: selectedVariations,
        })
    }

    onSideDishSelected = (sideDish) => {
        let { order, } = this.state
        const { order: orderItem, } = toggleSideDish({
            order, sideDish
        })

        this.setState({
            order: orderItem,
        }, this.handleSideDish)
    }
    /**
     *
     * @param {Object} sideDish
     * @param {Boolean} isAdd - true = add 1 to current quantity, false = -1 from current quantity
     */
    onSideDishChange = (sideDish, isAdd) => {
        let { order, } = this.state
        let _sideDishOverMaxQuantity = [...(this.state.sideDishOverMaxQuantity || [])]
        let { sideDishOverMaxQuantity, order: orderItem, } = handleSideDishChange({order, sideDish, isAdd, sideDishOverMaxQuantity: _sideDishOverMaxQuantity, })

        if (sideDishOverMaxQuantity && sideDishOverMaxQuantity.length) {
            if (this.sideDishOverMaxQuantityTimer) {
                clearTimeout(this.sideDishOverMaxQuantityTimer)
            }
            this.sideDishOverMaxQuantityTimer = setTimeout(() => {
                this.setState({sideDishOverMaxQuantity: []})
            }, 2000)
        }

        this.setState({
            order: orderItem,
            sideDishOverMaxQuantity: sideDishOverMaxQuantity,
        }, this.handleSideDish)
    }

    handleSideDish = () => {
        let { menuItem, } = this.props
        let sideDishes = [];
        if (menuItem.variation_group_id) {
            sideDishes = this.props.app.state.variation.sideDishes.filter((item) => item.variation_group_id == menuItem.variation_group_id)
            if (sideDishes.length <= 0) {
                sideDishes = this.props.app.state.variation.sideDishes.filter((item) => item.item_id == menuItem.id)
            }
        }
        else {
            sideDishes = this.props.app.state.variation.sideDishes.filter((item) => item.item_id == menuItem.id)
        }
        if (sideDishes.length == 0) {
            this.setState({
                isSideDishCompleted: true
            })
            return
        }

        const isSideDishCompleted = this.state.order.isSideDishCompleted()
        this.setState({
            isSideDishCompleted: isSideDishCompleted
        })
    }

    getRemainingQuantity = () => {
        let remainingQuantity = 999 // Default we set to some large positive number
        if (this.props.menuItem && this.props.menuItem.track_inventory && ModuleHelper.moduleEnabled(moduleKey.INVENTORY)) {
            // If has inventory tracking, get remaining quantity
            remainingQuantity = this.props.menuItem.getInventoryRemainingQuantity()
        }
        return remainingQuantity
    }

    handleOrderQuantityChanged = (add) => {
        let quantity = this.state.order_quantity
        const quantityBeforeChange = quantity

        const remainingQuantity = this.getRemainingQuantity() + this.getUnsavedQuantityChange()
        const maxQuantity = this.getItemMaxSelectableQuantity()
        // We still have inventory, can proceed to add item
        if (add) {
            if (remainingQuantity > 0 && quantity < 99) {
                quantity += 1
            }
            if (quantity > maxQuantity) {
                quantity = quantityBeforeChange
            }
        } else if (!add) {
            quantity -= (quantity > 1) * 1
        }

        this.setState({
            order_quantity: quantity,
            isOutOfStock: this.isOutOfStock(quantity),
        })
    }

    getItemMaxSelectableQuantity = () => {
        // getRemainingQuantity = Calculate using order information as per DB
        // If we change quantity without saving, getRemainingQuantity will always same value.
        // So need to adjust the value using unsave changes as well
        const remainingQuantity = this.getRemainingQuantity() + this.getUnsavedQuantityChange()
        const maxQuantity = this.state.order_quantity + remainingQuantity
        return maxQuantity
    }

    isOutOfStock = (finalQuantity, initialQuantity) => {
        const remainingQuantity = this.getRemainingQuantity()
        let quantityChanged = finalQuantity - this.state.openModalOriginalQuantity
        const isOutOfStock = remainingQuantity - quantityChanged < 0
        return isOutOfStock
    }

    joinTableThenPlaceOrder = (retryCount = 0) => {
        const isUsingRandomPINToCreateTable = true
        this.createTableSession(Util.getRandomNumber(), isUsingRandomPINToCreateTable).then(() => {
            this.pickItem(retryCount)
        }).catch((error) => {
            if (error == 1001) {
                // Table session exist.
                // Attempt to join table instead
                // Wait 1.5 sec, hope firebase already updated the data
                setTimeout(this.btnConfirmClicked, 1500);
            }
        });
    }
    btnConfirmClicked = () => {
        let isNotYetJoinActiveTable = TableSessionHelper.isNeedToTriggerJoinTable()
        if (isNotYetJoinActiveTable) {
            this.setState({
                ordering: false
            });
            this.props.app.setState({
                joiningTable: true
            })
            return
        }
        let me = this;
        //Check session

        if (table_session_id == null) {
            try {
                // This try block attempt to get user's consent
                // to join table by create/enter PIN.
                // Throw "abort" error if user decline/failed
                // to complete this step

                //if table session = null, check current table whether is lock or no.
                let table_session = this.props.app.state.table_session
                if (TableSessionHelper.isNeedToTriggerJoinTable()) {

                    // TODO:
                    // This is impossible part, double check then remove this session

                    let message = lang.table_lock_pin.replace("<br>", "\n")
                    let pin = prompt(message)
                    if (pin == null) {
                        throw "abort"
                    }
                    else if (pin != table_session.pin) { //PIN incorrect
                        alert(lang.incorrect_pin_again)
                        throw "abort"
                    }
                    else { //PIN correct
                        me.createTableSession(pin).then(function () {
                            me.pickItem()
                        });
                    }
                }
                else { // no table session pin
                    this.joinTableThenPlaceOrder()
                }
            }
            catch (err) {
                if (err == "abort") {
                    this.setState({ ordering: false })
                }
            }
        }
        else {
            //Check the user whether order in the same table
            if (this.props.app.state.table.id == this.props.app.state.current_session.table_id)
                this.pickItem()
            else { //current table id different with the table id in session
                this.setState({ ordering: false })
                let message = lang.unable_to_order.replace(":table", this.props.app.state.current_session.table_id)
                alert(message)
            }
        }
    }
    /**
     * @param {*} pin - PIN number
     * @param {*} isUsingRandomPINToCreateTable - Is this an attempt to create table session on open table
     */
    createTableSession(pin, isUsingRandomPINToCreateTable) {
        let me = this

        // We already fire API to join table, instead of duplicating join table API call,
        // wait until previous API returns, then trigger callback/resolve promise
        if (_joiningTable) {
            return new Promise((resolve, reject) => {
                // console.log("Joining table now, on hold add order until done join table")
                _joinTableCallbacks.push(() => {
                    // console.log("Resolving add pending order to table session")
                    resolve()
                })
            })
        }

        return new Promise(
            (resolve, reject) => {
                _joiningTable = true

                _joinTableCallbacks.push(() => {
                    // console.log("Resolving add first order to table session")
                    resolve()
                })
                $.ajax({
                    url: "/table/" + me.props.app.state.table.id + "/join_table",
                    type: "post",
                    data: {
                        merchant_id: me.props.app.state.table.merchant_id,
                        table_id: me.props.app.state.table.id,
                        pin: pin,
                        is_create_session: !!isUsingRandomPINToCreateTable ? 1 : 0,
                        is_from_marketplace: localStorage.getItem("source") === 'omp' || 0,
                        merchant_menu_id: me.props.app.state.selectedMerchantMenuId,
                        phone_number: localStorage.getItem('dine_in_phone_number'),
                        pax: localStorage.getItem('dine_in_pax'),
                    },
                    success: function (response) {
                        let message = lang.your_pin
                        let result = message.replace("*PIN*", pin)
                        table_session_id = response['id']
                        me.props.app.newSession();

                        // Done create table session regardless whether is redirected from
                        // marketplace, clear the source flag so next order will not be marked
                        // wrongly (possible entry point is scan qr to order or redirect from Marketplace)
                        localStorage.removeItem("source")

                        // Done join table, execute all pending callbacks
                        while (_joinTableCallbacks.length > 0) {
                            (_joinTableCallbacks.shift())()
                        }
                    },
                }).fail((xhr) => {
                    const json = JSON.parse(xhr.responseText)
                    if (json.error && json.error == 1001) {
                        reject(json.error)
                    }
                    else {
                        console.log(xhr)
                        if (json) {
                            alert(json.message)
                        }
                        else {
                            alert(lang.unable_to_join_table)
                        }
                        reject()

                        // Remove all pending calls as all these callbacks rely on join table SUCCESS
                        _joinTableCallbacks.clear()
                    }
                })
                .always(() => {
                    _joiningTable = false
                })
            })
    }
    pickItem(retryCount = 0) {
        let menuItem = this.props.menuItem
        let remarkId = '#order-remark-' + menuItem.id;
        let isTakeAway = $('#checkbox-takeaway-' + menuItem.id).prop("checked") ? 1 : 0
        let me = this
        if ( this.isPickupOrDelivery() && !this.isPickupOrDeliveryNotAutoSetTakeAway() ){
            isTakeAway = 1
        }

        let data = {
            menu_item_id: menuItem.id,
            quantity: this.state.order_quantity,
            remark: $(remarkId).val(),
            order_total: this.isPickupOrDelivery() ? this.getTotalPrice(true) : this.getTotalPrice(),
            order_total_delivery: this.getTotalPrice(true),
            take_away: isTakeAway,
            variation_ids: this.state.selected_variations.map((value) => value.id).join('|'),
            choice_ids: this.state.selected_choices.map((value) => value.id).join('|'),
            side_dish_data: this.state.order.side_dish_data,
            variation_data: this.state.order.variation_data,
            uuid: this.state.order.uuid || uniqueUuid(),
            set_number: this.state.setNumber || 1,
        }
        if (this.props.order != null) {
            data['update_order'] = true
            $.ajax({
                url: '/orders/' + this.props.order.id,
                type: 'PATCH',
                data: data,
                success: (order) => {
                    setTimeout(function () {
                        $('#btnClose').trigger('click')
                        $(document).trigger('menu-item-modal.is-ordering.success', [order])
                    }, 600);
                },
                complete: () => {
                    setTimeout(function () { me.setIsOrdering(false) }, 500);
                }
            }).fail(ajaxFails)
        } else {
            $.ajax({
                url: '/orders',
                type: 'POST',
                data: data,
                success: (order) => {
                    setTimeout(function () {
                        $('#btnClose').trigger('click')
                        $(document).trigger('menu-item-modal.is-ordering.success', [order])
                    }, 600);
                },
                complete: () => {
                    setTimeout(function () { me.setIsOrdering(false) }, 500);
                }
            }).fail((xhr) => {
                if (retryCount < 3) {
                    retryCount++
                    try {
                        let { errorCode, message } = getAjaxError(xhr)
                        if (errorCode == ERR_TABLE_SESSION_NOT_FOUND) {
                            this.joinTableThenPlaceOrder(retryCount)
                        }
                        else {
                            ajaxFails(xhr)
                        }
                    }
                    catch {
                        ajaxFails(xhr)
                    }
                }
                else {
                    alert("Fail to place order, please try refresh page and try again.")
                    pageReload.reload()
                }
            })
        }
    }

    setIsOrdering(isOrdering) {
        const triggerEvent = () => {
            $(document).trigger('menu-item-modal.is-ordering.change', [isOrdering])
        }
        if (!this.unmounted) {
            this.setState({ ordering: isOrdering }, () => {
                triggerEvent()
            })
        }
        else {
            triggerEvent()
        }
    }

    getTotalPrice(isDelivery) {
        let totalPrice = 0
        let totalPriceDelivery = 0
        if (this.state.selected_choices.length != 0) {
            this.state.selected_choices.map((choice) => {
                totalPrice += parseFloat(choice.price)
                totalPriceDelivery += parseFloat(choice.price_delivery != null ? choice.price_delivery : choice.price)
            })
        } else {
            totalPrice += parseFloat(this.props.menuItem.price)
            totalPriceDelivery += parseFloat(this.props.menuItem.price_delivery != null ? this.props.menuItem.price_delivery : this.props.menuItem.price)
        }

        const variationData = this.state.order.variation_data
        const variationSelections = variationData && variationData.selections || []
        this.state.selected_variations.map((variation) => {
            if (variation.price != null || variation.price != 0) {
                let quantity = 1
                if (variationSelections) {
                    const variationQuantity = variationSelections.find(v => v.variation_id == variation.id)
                    if (variationQuantity) {
                        quantity = variationQuantity.quantity
                    }
                }
                totalPrice += parseFloat(variation.price) * quantity
                totalPriceDelivery += parseFloat(variation.price_delivery ? variation.price_delivery : variation.price) * quantity
            }
        })
        let { order: { side_dish_data = {} }, } = this.state
        let selections = side_dish_data.selections ? [...side_dish_data.selections] : []
        selections.forEach(sideDishSelection => {
            if (sideDishSelection.variation.price && sideDishSelection.variation.price != 0) {
                const sideDishAddOnPrice = parseFloat(sideDishSelection.variation.price) * sideDishSelection.quantity
                totalPrice += sideDishAddOnPrice
                totalPriceDelivery += sideDishAddOnPrice
            }
        })

        if ($('#checkbox-takeaway-' + this.props.menuItem.id).prop('checked')) {
            totalPrice = totalPrice + parseFloat(this.props.menuItem.take_away_charge)
        }
        return (isDelivery ? totalPriceDelivery : totalPrice) * this.state.order_quantity
    }

    isPickupOrDelivery = () => {
        return this.props.isPickupOrDelivery
    }
    isPickupOrDeliveryNotAutoSetTakeAway = () => {
        return this.props.app.getMerchantSettingValue('pickup_do_not_auto_set_as_take_away') == 1
    }

    render() {
        if (this.props.menuItem != null) {
            $('body').addClass('modal-open');
        }
        return <MenuItemModalPortal>
            <Modal
                visible={this.props.menuItem != null && !this.props.app.state.joiningTable}
                closemodal={this.onClose.bind(this)}
                type="fadeInUp">
                <div className="menu-modal">
                    {
                        this.props.menuItem != null &&
                        <>
                            {this.renderModalHeader()}
                            <div className="mb-2">
                                <MenuItemImageGallery app={this.props.app} menuItem={this.props.menuItem} menuItemImages={this.state.menuItemImages} />
                            </div>
                            {
                                this.props.menuItem.description ?
                                <>
                                    <ul className="nav nav-tabs justify-content-center mt-4 " style={{display: "flex", textAlign: "center"}}>
                                        <li className="nav-item active" style={{flex: "1 0 100px"}}>
                                            <a className="nav-link" id="tabBasic" data-toggle="tab" href="#tabpaneSelection" role="tab" aria-controls="contact" aria-selected="false">
                                                {lang.title_choice}
                                            </a>
                                        </li>
                                        <li className="nav-item" style={{flex: "1 0 100px"}}>
                                            <a className="nav-link" id="tabFeature" data-toggle="tab" href="#tabpaneInfo" role="tab" aria-controls="contact" aria-selected="false">
                                                {lang.description}
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="tabContent" >
                                        <div className="tab-pane fade in active" id="tabpaneSelection" role="tabpanel" aria-labelledby="home-tab">
                                            {this.renderItemVariation()}
                                        </div>
                                        <div className="tab-pane fade" id="tabpaneInfo" role="tabpanel" aria-labelledby="home-tab" style={{minHeight: "200px"}}>
                                            <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.menuItem.description)}} >
                                            </div>
                                        </div>
                                    </div>
                                </> :
                                this.renderItemVariation()
                            }
                            {/* {this.renderItemVariation()} */}
                            {
                                this.isAllowOrder() ?
                                (
                                    !this.isDineInTable() || WorkingHourHandler.isWithinWorkingHour() ?
                                    this.renderModalBottom() :
                                    <ViewMenuOnlyHint menuItem={this.props.menuItem} message={<div style={{paddingTop: "8px"}}>{lang.business_is_closed}</div>}  />
                                ) :
                                <ViewMenuOnlyHint menuItem={this.props.menuItem} message={this.state.isOutOfStock ? lang.out_of_stock : ""} />
                            }
                        </>
                    }
                </div>
            </Modal>
        </MenuItemModalPortal>
    }
    getMaxSideDish = (group) => {
        return this.props.menuItem.getMaxSideDish(group)
    }
    getMinSideDish = (group) => {
        return this.props.menuItem.getMinSideDish(group)
    }
    isDineInTable = () => {
        const table = this.props.app.state.table
        if (table && (table.table_type_bitwise & TableType.BIT_DINEIN)) {
            return true
        }
        return false
    }
    isAllowOrder = () => {
        const table = this.props.app.state.table
        if (table && (table.table_type_bitwise & TableType.BIT_DINEIN) && !table.allow_dine_in_order) {
            return false
        }
        if (this.state.isNewItem && this.state.isOutOfStock) {
            return false
        }
        return true
    }
    renderModalHeader() {
        let inventoryRemaining = this.getRemainingQuantity()
        let choices = this.props.app.state.variation.choices.filter((item) => item.item_id == this.props.menuItem.id)
        let isSubtitleExist =
        this.props.menuItem.subtitle ? <span style={{ fontSize: "12px", color: "#909090", fontStyle: "italic", minWidth: "50%", display: "inline-block" }}>{this.props.menuItem.subtitle}</span> : ""
        return this.props.menuItem && <div className="menu-modal-header">
            <i id="btnClose" className="fas fa-times" onClick={() => { $('.react-modal-body-close').trigger('click') }}></i>
            <div className="item-name">
                {this.props.menuItem.name} {this.props.menuItem.hot_product == '1' && hotProductIcon}
                {
                    inventoryRemaining <= 10 && inventoryRemaining > 0 &&
                    <span style={{ fontSize: "14px", color: "#909090", fontStyle: "italic", minWidth: "50%", display: "inline-block"}}>
                        ({`Only ${inventoryRemaining} left`})
                    </span>
                }
            </div>
            {isSubtitleExist}

            <div>
                {this.props.menuItem.take_away_charge < 0 || this.isPickupOrDelivery() ? null :
                    <div className="form-group pull-right" style={{ marginBottom: "5px" }}>
                        <div className="checkbox" style={{ marginTop: "0px", marginBottom: "0px" }}>
                            <label>
                                <input type="checkbox" id={"checkbox-takeaway-" + this.props.menuItem.id} className="pull-right" onClick={() => {
                                    this.forceUpdate()
                                }}
                                    onChange={() => {
                                        const order = cloneOrder(this.state.order, {
                                            take_away: !this.state.order.take_away
                                        })
                                        this.setState({order})
                                    }}
                                    checked={!!this.state.order.take_away}
                                />{lang.take_away}<span> {this.props.menuItem.take_away_charge == 0 ? null : "+ "+this.props.app.state.currencyName + (this.props.menuItem.take_away_charge * 1).toFixed(2)}</span>
                            </label>
                        </div>
                    </div>
                }
            </div>
            <hr className="line" />
        </div>
    }

    getItemChoiceVariationOptionSideDish = () => {
        let menuItem = this.props.menuItem
        let choices = [];
        let options = [];
        let addons = [];
        let sideDishes = [];
        if (menuItem.variation_group_id) {
            choices = this.props.app.state.variation.choices.filter((item) => item.variation_group_id == menuItem.variation_group_id)
            sideDishes = this.props.app.state.variation.sideDishes.filter((item) => item.variation_group_id == menuItem.variation_group_id)
            if (sideDishes.length <= 0) {
                sideDishes = this.props.app.state.variation.sideDishes.filter((item) => item.item_id == menuItem.id)
            }
            options = this.props.app.state.variation.options.filter((item) => item.variation_group_id == menuItem.variation_group_id)
            addons = this.props.app.state.variation.addons.filter((item) => item.variation_group_id == menuItem.variation_group_id)
        } else {
            choices = this.props.app.state.variation.choices.filter((item) => item.item_id == menuItem.id)
            sideDishes = this.props.app.state.variation.sideDishes.filter((item) => item.item_id == menuItem.id)
            options = this.props.app.state.variation.options.filter((item) => item.item_id == menuItem.id)
            addons = this.props.app.state.variation.addons.filter((item) => item.item_id == menuItem.id)
        }
        return { choices, options, addons, sideDishes }
    }
    renderItemVariation() {
        if (!this.props.menuItem) {
            return null
        }
        let menuItem = this.props.menuItem
        let sideDishDetails = this.props.menuItem.side_dish_detail || []
        const { choices, options, addons, sideDishes } = this.state.choiceVariationOptionSideDish

        const allowRemark = menuItem.getCategory() && menuItem.getCategory(true).allow_remark

        let { isSideDishCompleted } = this.state
        return (
            <div className="menu-option-body" >
                {
                    !!this.props.menuItem.hint &&
                    <div style={{paddingLeft: "10px", paddingRight: "10px"}}>
                        {this.props.menuItem.hint}
                    </div>
                }
                {choices.length > 0 ?
                    <MenuItemOptions
                        className="choices"
                        title={menuItem.choice_title && menuItem.choice_title[selectedLang] || lang.title_choice}
                        menuItem={menuItem}
                        variations={choices}
                        selected_variations={this.state.selected_choices}
                        onSelected={this.onVariationSelected.bind(this)}
                        withFee={true}
                        selectedVariations={[]}
                        highlightSelected={true}
                        collapsible={false}
                        isPickupOrDelivery={this.isPickupOrDelivery()}
                        feePrefix={this.props.app.state.currencyName}
                    /> : null}

                {
                    sideDishes.length > 0 &&
                    sideDishDetails.map((sdd, index) => {

                        let sideDishStyle = this.state.isNeedFocus == "side-dish" && this.state.isNeedFocusSideGroup == sdd.group ? {
                            border: "1px solid red",
                            marginBottom: "-5px",
                            marginTop: "5px",
                            marginRight: "-5px",
                            marginLeft: "-5px",
                            paddingRight: "4px",
                            paddingLeft: "4px",
                            paddingBottom: "4px",
                            borderRadius: "5px",
                        } : {}

                        let sddGroupItems = sideDishes.filter(sd => sd.group == sdd.group)
                        if (sddGroupItems.length == 0) {
                            return null
                        }
                        if (!this.sideDishContainerRef[sdd.group]) {
                            this.sideDishContainerRef[sdd.group] = React.createRef()
                        }

                        let sideDishHint = null
                        if (sddGroupItems.length > 0) {
                            let hintStyle = isSideDishCompleted[sdd.group] ? {fontWeight: "bold", color: "green"} : {}
                            let { isCompletedMessage, sideDishMessage, } = getSideDishMessage({order: this.state.order, isSideDishCompleted, sdd})
                            isCompletedMessage = isCompletedMessage ? <span className="text-success pull-right">{isCompletedMessage}</span> : null
                            sideDishHint = <div style={{paddingLeft: "10px", paddingRight: "10px"}}>
                                <span style={hintStyle}>
                                    {sideDishMessage}
                                </span>
                                {isCompletedMessage}
                            </div>
                        }

                        const disableAutoCollapse = this.props.app.getMerchantSettingValue('menu_item_modal_sidedish_disable_auto_collapse') == 1

                        return <div key={sdd.group} ref={this.sideDishContainerRef[sdd.group]} style={sideDishStyle}>
                            <MenuItemOptions
                                sideDishGroup={sdd.group}
                                className="side-dish"
                                defaultExpanded={this.props.app.getMerchantSettingValue('menu_item_modal_sidedish_default_expanded')}
                                classNameCollapsible={`side-dish-${sdd.group}`}
                                forceExpand={this.state.sideDishForceExpand[sdd.group]}
                                title={sdd.side_dish_title && (sdd.side_dish_title[selectedLang] || sdd.side_dish_title["en"]) || lang.title_side_dish}
                                maxSideDishQuantity={this.getMaxSideDish(sdd.group)}
                                showQuantityAdjust={true}
                                onSelected={this.onSideDishSelected}
                                hint={sideDishHint}
                                menuItem={menuItem}
                                variations={sddGroupItems}
                                selectedSideDishes={this.state.order.side_dish_data && this.state.order.side_dish_data.selections || []}
                                isSideDish={true}
                                onSideDishChange={this.onSideDishChange}
                                isPickupOrDelivery={this.isPickupOrDelivery()}
                                showPositiveSign={true}
                                feePrefix={this.props.app.state.currencyName}
                                collapseWhenOtherExpand={disableAutoCollapse ? CollapseWhenOtherExpandType.never : CollapseWhenOtherExpandType.all}
                                sideDishOverMaxQuantity={this.state.sideDishOverMaxQuantity}
                            />
                        </div>
                    })
                }

                {addons.length > 0 ?
                    <MenuItemOptions
                        className="addons"
                        title={menuItem.add_on_title && menuItem.add_on_title[selectedLang] || lang.title_addon}
                        menuItem={menuItem}
                        variations={addons}
                        selected_variations={this.state.selected_variations}
                        onSelected={this.onVariationSelected}
                        withFee={true}
                        isPickupOrDelivery={this.isPickupOrDelivery()}
                        defaultExpanded={this.props.app.getMerchantSettingValue('menu_item_modal_addon_default_expanded')}
                        showPositiveSign={true}
                        selectedVariations={this.state.order.variation_data && this.state.order.variation_data.selections || []}
                        onVariationQuantityChange={this.onVariationQuantityChange}
                        variationOverMaxQuantity={this.state.variationOverMaxQuantity}
                        feePrefix={this.props.app.state.currencyName}
                        collapseWhenOtherExpand={this.props.app.getMerchantSettingValue('menu_item_modal_addon_disable_auto_collapse') == 1 ? CollapseWhenOtherExpandType.never : CollapseWhenOtherExpandType.all}
                    /> : null}

                {options.length > 0 ?
                    <MenuItemOptions
                        className="options"
                        title={menuItem.option_title && menuItem.option_title[selectedLang] || lang.title_option}
                        menuItem={menuItem}
                        variations={options}
                        selected_variations={this.state.selected_variations}
                        onSelected={this.onVariationSelected}
                        isPickupOrDelivery={this.isPickupOrDelivery()}
                        defaultExpanded={this.props.app.getMerchantSettingValue('menu_item_modal_option_default_expanded')}
                        showPositiveSign={true}
                        selectedVariations={this.state.order.variation_data && this.state.order.variation_data.selections || []}
                        onVariationQuantityChange={this.onVariationQuantityChange}
                        variationOverMaxQuantity={this.state.variationOverMaxQuantity}
                        feePrefix={this.props.app.state.currencyName}
                        collapseWhenOtherExpand={this.props.app.getMerchantSettingValue('menu_item_modal_option_disable_auto_collapse') == 1 ? CollapseWhenOtherExpandType.never : CollapseWhenOtherExpandType.all}
                    /> : null}

                { allowRemark && <MenuItemOptions
                    className="remark"
                    isPickupOrDelivery={this.isPickupOrDelivery()}
                    title={lang.title_remark}
                    defaultExpanded={this.props.app.getMerchantSettingValue('menu_item_modal_remark_default_expanded')}
                    body={this.renderRemark(menuItem)}
                    feePrefix={this.props.app.state.currencyName}
                    collapseWhenOtherExpand={this.props.app.getMerchantSettingValue('menu_item_modal_remark_disable_auto_collapse') == 1 ? CollapseWhenOtherExpandType.never : CollapseWhenOtherExpandType.all} />
                }
            </div>
        )
    }
    isWithinMerchantMenuHours = (merchantMenu) => {
        if (merchantMenu.is_all_day) {
            return true
        }
        if (merchantMenu.time_start && merchantMenu.time_end) {
            let timeStart = moment(merchantMenu.time_start, "HH:mm")
            let timeEnd = moment(merchantMenu.time_end, "HH:mm")
            let isBetween = moment().isBetween(timeStart, timeEnd, undefined, "[]")
            return isBetween
        }
        return true
    }
    getUnsavedQuantityChange = () => {
        return this.state.openModalOriginalQuantity - this.state.order_quantity
    }
    handleRemoveItem = () => {
        this.setState({
            isCancellingOrder: true
        })
        this.props.onCancelOrder && this.props.onCancelOrder(this.state.order, () => {
            this.setState({
                isCancellingOrder: false
            })
            setTimeout(() => {
                this.onClose()
            }, 500)
        })
    }
    renderModalBottom() {
        const { selectedMerchantMenuId } = this.props.app.state
        if (this.isDineInTable() && selectedMerchantMenuId) {
            let merchantMenu = this.props.app.state.merchantMenus.find(mm => mm.id == selectedMerchantMenuId)
            if (merchantMenu && !this.isWithinMerchantMenuHours(merchantMenu)) {
                const formatTime = (timeStr) => {
                    return moment(timeStr, "HH:mm").format("hh:mm a")
                }
                let menuTime = `${formatTime(merchantMenu.time_start)} - ${formatTime(merchantMenu.time_end)}`
                let cannotOrderFromMenuStr = lang.cannot_order_from_menu.replace("%time%", menuTime)
                return <ViewMenuOnlyHint menuItem={this.props.menuItem} message={<div style={{paddingTop: "8px"}}>{cannotOrderFromMenuStr}</div>} />
            }
        }
        if (this.state.isTableSessionExpired) {
            return <ViewMenuOnlyHint menuItem={this.props.menuItem} message={<div style={{paddingTop: "8px"}}>{lang.order_disabled_please_get_another_qr_code}</div>} />
        }
        else if (this.state.isOrderTimeExpired && this.props.menuItem.is_limit_order_time) {
            return <ViewMenuOnlyHint menuItem={this.props.menuItem} message={<div style={{paddingTop: "8px"}}>{lang.exceed_order_duration.replace("%minute%", window.order_duration)}</div>} />
        }

        const { isSideDishCompleted, selected_choices } = this.state


        let remainingQuantity = this.props.menuItem.track_inventory ? this.props.menuItem.getInventoryQuantity() : 999
        remainingQuantity = remainingQuantity < 0 ? 0 : remainingQuantity

        remainingQuantity = this.getItemMaxSelectableQuantity()
        let showInventoryHint = this.props.menuItem.track_inventory && (this.state.isOutOfStock || remainingQuantity < 10)
        let inventoryItemHint = showInventoryHint && `${lang.n_item_left.replace("%n%", remainingQuantity)}`

        const showLoading = this.state.ordering || this.state.isCancellingOrder

        // Selected choice has z-index = 2, so will overlap this component.
        // Set zIndex: "3" to workaround
        return this.props.menuItem && <div className="menu-modal-bottom" style={{zIndex: "3"}}>
            <hr className="line" />
            <div className="mt-1 mb-1 text-danger">
                {this.state.cartErrorMsg}
            </div>

            {
                this.props.app.isOrderSetBySet() && this.getDraftOrders().length > 0 &&
                <div className="mb-1">
                    <OrderSetButton
                        extraSetNumbers={this.props.extraSetNumbers || []}
                        defaultOrderingSetNumber={this.state.setNumber}
                        style={{textAlign: "right"}}
                        orders={this.props.app.state.orders}
                        onSetNumberChange={this.onSetNumberChange}
                        isAllowCreateNewSetNumber={this.isAllowCreateNewSetNumber}
                    />
                </div>
            }

            {
                showLoading && <div className="btn-wrapper">
                    <PulseLoader color="#ffa733" size="8px" style={{ textAlign: "center", paddingTop: '6px', height: "38px" }} />
                </div>
            }
            <div className="btn-wrapper" style={{display: showLoading ? "none" : "flex", justifyContent: "space-between", }}>
                {
                    remainingQuantity > 0 ?
                    <QuantityAdjust
                        className={this.props.className}
                        ordering={this.state.ordering}
                        order_quantity={this.state.order_quantity}
                        menuItem={this.props.menuItem}
                        handleOrderQuantityChanged={this.handleOrderQuantityChanged}
                        hintWarning={inventoryItemHint}
                    /> :
                    <div>
                        {lang.out_of_stock}
                    </div>
                }
                {
                    remainingQuantity <= 0 &&
                    <div>
                        <button type="button" className="btn btn-danger" onClick={this.handleRemoveItem}>{lang.remove_item}</button>
                    </div>
                }
                {
                    remainingQuantity > 0 &&
                    <div>
                        <AddToCart
                            disabled={true}
                            isOutOfStock={this.state.isOutOfStock}
                            cartErrorMsg={this.state.cartErrorMsg}
                            onClick={() => {
                                if(selected_choices && selected_choices.length > 0 && !selected_choices[0].in_stock) {
                                    alert(lang.choice_no_stock)
                                    return
                                }

                                let sddGroups = Object.keys(isSideDishCompleted)
                                for (let group of sddGroups) {
                                    if (!isSideDishCompleted[group]) {
                                        // Found at least one side dish group that is not complete
                                        this.setSideDishErrorMessage(group)
                                        return
                                    }
                                }

                                this.setState(
                                    { ordering: true },
                                    () => {
                                        // Set a minor delay here so that the loading indicator
                                        // is shown before the prompt to add/set PIN
                                        setTimeout(() => {
                                            this.btnConfirmClicked()
                                            $(document).trigger('MenuItemModal.addToCartClicked')
                                        }, 250)
                                    }
                                )
                            }}
                            currencyName={this.props.app.state.currencyName}
                            totalPrice={(this.getTotalPrice(this.isPickupOrDelivery()) * 1).toFixed(2)}
                            order={this.props.order}
                        />
                    </div>
                }
            </div>
            {
                this.state.isOutOfStock && this.state.isNewItem &&
                <div>
                    {lang.out_of_stock}
                </div>
            }
        </div>
    }
    renderRemark() {
        let remarkId = "order-remark-" + this.props.menuItem.id;
        return <input key={this.props.menuItem.id} defaultValue={this.props.order != null ? this.props.order.remark || "" : ""} type="text" className="form-control menu-option-remark" id={remarkId} maxLength="30" placeholder={lang.hint_max_char} />
    }
    onSetNumberChange = (setNumber) => {
        this.props.onSetNumberChange && this.props.onSetNumberChange(setNumber)
        this.setState({setNumber})
    }
    getDraftOrders = () => {
        return (this.props.app.state.orders || []).filter(o => o.order_status == 'draft')
    }
    isAllowCreateNewSetNumber = () => {
        const { order } = this.state
        const currentSetNumber = order.set_number
        if (currentSetNumber) {
            // If this order is the only item in this set, do not allow
            // create new set number
            let orderCount = this.getDraftOrders().filter(o => o.set_number == currentSetNumber).length
            return orderCount > 1
        }
        return true
    }
    setSideDishErrorMessage = (group) => {
        this.setState({
            isNeedFocus: "side-dish",
            isNeedFocusSideGroup: group,

            // sideDishForceExpand: {
            //    group: someRandomValue,
            //     1: xxx,
            //     2: yyy,
            //     3: zzz
            // }
            // Changing this someRandomValue to otherRandomValue shall expand the collapsible.
            // We generate the otherRandomValue by otherRandomValue = someRandomValue + 1

            // Update this number to force MenuItemOption to expand
            sideDishForceExpand: {
                ...this.state.sideDishForceExpand,
                [group]: (this.state.sideDishForceExpand[group] || 0) + 1
            },
            cartErrorMsg: lang.please_complete_your_side_dish_ordering
        }, () => {
            if (this.cartErrorMsgTimeout) {
                clearTimeout(this.cartErrorMsgTimeout)
            }
            this.cartErrorMsgTimeout = setTimeout(() => {
                this.setState({
                    isNeedFocus: null,
                    cartErrorMsg: null,
                    isNeedFocusSideGroup: null,
                })
            }, 2000);
        })
    }
}

class AddToCart extends Component {
    render() {
        const { isOutOfStock } = this.props
        return (
            <table id="add-to-cart" className="btn btn-success btn-menu-modal-add" disabled={isOutOfStock} style={{cursor: isOutOfStock ? "not-allowed" : "pointer"}}
                onClick={isOutOfStock ? null : this.props.onClick}>
                <tbody>
                    <tr>
                        <td id="menu-item-modal-btn-add-to-cart" className="btn-text-add-hint">{this.props.order != null ? lang.update_cap : lang.add_to_cart}</td>
                        <td className="btn-text-add-price">{this.props.currencyName+" " + this.props.totalPrice}</td>
                    </tr>
                </tbody>
            </table>
        )
    }
}
class ViewMenuOnlyHint extends Component {
    render() {
        return (
            this.props.menuItem && <div className="menu-modal-bottom" style={{ paddingBottom: "20px" }}>
                <hr className="line" />
                <div className="btn-wrapper">
                    {this.props.message || lang.ordering_is_disabled}
                </div>
            </div>
        )
    }
}
MenuItemModal.defaultProps = {
    order: null
}
export default MenuItemModal;

